module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/th/4-82c8dd02f7abaa2f41bbe8aceaebc61b.jpg";